<div *ngIf="modal$ | async as modal">
  <div class="modal-header">
    <h4
      class="mat-body-1 font-weight-bold text-center"
      data-cy="modal-title"
    >{{ modal?.title }}</h4>
    <h6 class="mat-body-1 font-weight-bold text-center">
      {{ modal?.subTitle }}</h6>
  </div>
  <div class="modal-body">
    <p class="mat-body-1 font-weight-normal text-center">
      {{ modal?.message }}</p>
    <ng-content></ng-content>
  </div>
  <div
    class="modal-footer buttons"
    [ngSwitch]="modal.type"
  >
    <div *ngSwitchCase="ModalActions.CONFIRM_ACTION">
      <button
        color="accent"
        class="mr-3"
        mat-button
        type="button"
        data-cy="modal-cancel-button"
        (click)="cancel()"
      >{{ modal?.cancelText }}</button>
      <!--             [class.btn-danger]="modal?.buttonType === modalButtonType.danger" -->
      <button
        color="primary"
        class="md"
        [disabled]="disableSave && modal.isCommentRequired"
        (click)="confirm()"
        data-cy="modal-confirm-button"
        mat-flat-button
        type="button"
      >{{ modal?.confirmText }}</button>
    </div>
    <div *ngSwitchCase="ModalActions.CONFIRM_MESSAGE">
      <button
        color="primary"
        class="md confirm-message"
        mat-flat-button
        data-cy="modal-accept-message"
        type="button"
        (click)="close()"
      >{{ modal?.confirmText }}</button>
    </div>
  </div>
</div>
